import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { clientGET } from 'Core/data/RestApi';

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  urlFileCsv: null,
  csvFile: null
};

const route = "modules/workOrders/views/customerTab/modals/importCustomers/redux/slice";

export const workOrderImportCustomers = createAsyncThunk("workOrders/workOrderImportCustomers/importCustomers", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation importCustomers ($fileKey: String!, $delimiter: String!) {
        result: importCustomers (fileKey: $fileKey, delimiter: $delimiter) {
          stepFunctionId
          transactionId
          transactionType
          processStartDate
        }
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

  } catch (exc) {
    ExceptionManager(exc, route, "importCustomers");
    return rejectWithValue(exc);
  }
});

export const workOrderDownloadAttachmentUrl = createAsyncThunk("workOrders/workOrderImportCustomers/downloadAttachmentUrl", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `query (
        $id: Int!
      ){
          result: downloadAttachmentUrl(
            id: $id
          )
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    if (response && response.result && response.result) {
      return response.result
    } else throw 'There are not url attachment';

  } catch (exc) {
    ExceptionManager(exc, route, "downloadAttachmentUrl");
    return rejectWithValue(exc);
  }
}
);

export const workOrderloadFileCsv = createAsyncThunk("workOrders/workOrderImportCustomers/loadFileCsv", async (payload, { rejectWithValue }) => {
  try {
    const { url } = payload;
    const result = await clientGET('', {}, url, false);
    return result
  } catch (exc) {
    ExceptionManager(exc, route, "loadFileCsv");
    return rejectWithValue(exc);
  }
});

const workOrdersImportCustomersRedux = createSlice({
  name: "workOrders/importCustomers",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalImportCustomers(state, action) {
      state.open = action.payload.open;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //workOrderImportCustomers
    builder.addCase(workOrderImportCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderImportCustomers.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(workOrderImportCustomers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //workOrderDownloadAttachmentUrl
    builder.addCase(workOrderDownloadAttachmentUrl.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderDownloadAttachmentUrl.fulfilled, (state, action) => {
      state.loading = false;
      state.urlFileCsv = action.payload;
    });
    builder.addCase(workOrderDownloadAttachmentUrl.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //workOrderloadFileCsv
    builder.addCase(workOrderloadFileCsv.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrderloadFileCsv.fulfilled, (state, action) => {
      state.loading = false;
      state.csvFile = action.payload;
    });
    builder.addCase(workOrderloadFileCsv.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersImportCustomersRedux;

// Extract and export each action creator by name
export const { reset, openModalImportCustomers } = actions;

// Export the reducer, either as a default or named export
export default reducer;